import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import queryString from 'query-string';
import { useInfiniteQuery } from 'react-query';
import { NumericArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { toPascalCase } from '../helpers';
import { ListResModel, WidgetBodyModel } from '../models';

export function useListWidget({ body, id }: { body: WidgetBodyModel; id: number }) {
  const [query] = useQueryParams({
    startDate: StringParam,
    finishDate: StringParam,
    responsibleByIds: NumericArrayParam
  });

  const parseQuery = queryString.stringify(query);

  const initialPage = Number(body?.[`filter${toPascalCase(body?.objectType || 'LogClient')}`]?.page) || 1;
  const initialSize = Number(body?.[`filter${toPascalCase(body?.objectType || 'LogClient')}`]?.size) || 10;

  const { data, ...arg } = useInfiniteQuery<ListResModel>(
    ['dashboard-v2-list', id, parseQuery],
    async ({ pageParam = initialPage }) => {
      body.page = pageParam;
      body.size = initialSize;

      const { data } = await $api.post(`/v1/dashboard/widget/table${parseQuery ? `?${parseQuery}` : ''}`, body);

      return {
        ...data?.data,
        data: (data?.data?.data as any[])?.map(item => ({
          ...item,
          createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
        }))
      };
    },
    {
      enabled: !!body?.dashboardId,
      getNextPageParam: (_, page) => (page.length || 1) + 1
    }
  );

  const totalInfo = {
    totalPages: 1,
    totalElements: 0,
    currentPage: 1
  };

  let list: any[] = [];
  const dataToFlat = data?.pages?.flat();

  dataToFlat?.forEach(({ data, currentPage, totalElements, totalPages }, i) => {
    if (dataToFlat?.length === i + 1) {
      totalInfo.totalPages = totalPages;
      totalInfo.currentPage = currentPage;
      totalInfo.totalElements = totalElements;
    }

    list = [...list, ...data];
  });

  return { ...totalInfo, list, ...arg };
}
